import React, { useState } from 'react';
import ActiveConfirmDialog from './ActiveConfirmDialog'

const ToggleButton = ({ initialStatus, onUpdateStatus }) => {
  const [status, setStatus] = useState(initialStatus);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const toggleStatus = () => {
    if (status === 1) {
      setDialogMessage("Are you sure you want to set the status to 'Inactive'?");
    } else {
      setDialogMessage("Are you sure you want to set the status to 'Active'?");
    }
    setDialogOpen(true);
  };

  const handleConfirm = () => {
    setStatus((prevStatus) => {
      const newStatus = prevStatus === 1 ? 0 : 1;
      onUpdateStatus(newStatus);
      return newStatus;
    });
    setDialogOpen(false);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const buttonStyle = {
    padding: '2px 2px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '5px',
    border: 'none',
    outline: 'none',
    color: 'white',
    backgroundColor: status === 1 ? '#4CAF50' : '#FFA500',
  };

  return (
    <>
      <button style={buttonStyle} onClick={toggleStatus}>
        {status === 1 ? 'Active' : 'Inactive'}
      </button>
      <ActiveConfirmDialog
        open={dialogOpen}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        message={dialogMessage}
      />
    </>
  );
};

export default ToggleButton;